import { accountIdFormat } from "@redotech/redo-account-id";
import * as z from "zod";

/** Merchants with the supplies storefront on, for shipping-rule targeting. */
export const getSuppliesEnabledMerchants = {
  name: "getSuppliesEnabledMerchants" as const,
  input: z.object({}),
  output: z.object({
    merchants: z.array(
      z.object({ accountId: accountIdFormat.schema, name: z.string() }),
    ),
  }),
};
